import FilterCourses from "common/components/HeaderFilterCourses/FilterCourses";
import React, { useCallback, useEffect, useState } from "react";
import "./styles.scss";
import InputMobile from "common/components/InputMobile";
import FilterStudentFolder from "../FilterStudentFolder";
import { format } from "date-fns";

interface Props {
  onSearch?: (text: string) => void;
  onCheck?: (val: any) => void;
  onChangeLesson?: (val: number) => void;
}

const HeaderStudentFolder = ({ onSearch, onCheck, onChangeLesson }: Props) => {
  const [checkedLevel, setCheckedLevel] = useState({
    ease: false,
    hard: false,
    medium: false
  });

  useEffect(() => {
    const resLevels = localStorage.getItem("levels");
    if (resLevels) {
      setCheckedLevel(JSON.parse(resLevels));
    }
  }, []);

  const onCheckItem = useCallback(
    (val: "hard" | "ease" | "medium") => {
      const res = { ...checkedLevel, [val]: !checkedLevel[val] };
      setCheckedLevel(res);

      const arrayLevel = [];

      if (res?.ease) {
        arrayLevel.push("10");
      }
      if (res?.medium) {
        arrayLevel.push("20");
      }
      if (res?.hard) {
        arrayLevel.push("30");
      }
      localStorage.setItem("levels", JSON.stringify(res));
      onCheck && onCheck(res);
    },
    [checkedLevel, onCheck]
  );

  return (
    <div className="header-student-folder-wrapper">
      <div className="header-student-folder">
        <div className="time-student-folder">
          <span>{format(new Date(), "HH:mm")}</span>
          <span style={{ marginLeft: 16 }}>{format(new Date(), "dd/MM/yy")}</span>
        </div>
        <div className="header-student-folder-filter">
          <FilterStudentFolder onChangeLesson={onChangeLesson} />
          <FilterCourses onChangeLevel={onCheckItem} levels={checkedLevel} />
        </div>
      </div>
      <InputMobile isSearch onChangeText={onSearch} />
    </div>
  );
};

export default HeaderStudentFolder;
